import logo from './logo.svg';
import './App.css';
import HeroSection from './Components/HeroSection';
import AboutSection from './Components/AboutSection';
import DietSection from './Components/DietSection';
import ClientSection from './Components/ClientSection';
import Nutritionist from './Components/Nutritionist';
import Icons from './Components/Icons';
import Testimonials from './Components/Testimonials';
import Footer from './Components/Footer';
import EmailPopup from './Components/EmailPopup';

function App() {
  return (
    <>
    <EmailPopup/>
    <HeroSection/>
    <AboutSection/>
    <DietSection/>
    <ClientSection/>
    <Nutritionist/>
    <Icons/>
    <Testimonials/>
    <Footer/>
    </>
  );
}

export default App;
